import * as FwDatas from "../../FwDatas.ts";
import * as i18n from "../../i18n.ts";

//if we do $.extend({},aTruePrototype) it does not work, so we build a fake proto
const ISharableByMemberProto = {
  isShared(): boolean {
    return this.sharedToAll || (this.sharedMemberIds && this.sharedMemberIds.length>1);
  },
  sharedMembers(): any[] {
    var
      result: any[] = [],
      members = FwDatas.getFamily().members,
      sharedIds = this.sharedMemberIds||[],
      sharedToAll = this.sharedToAll;
    members.forEach(function(member: any){
      if(member.isloggedaccount){
        return;
      }
      function MemberSharedView(this: any, shared: boolean){
        this.shared=shared;
      }
      MemberSharedView.prototype=member;
      result.push(new (MemberSharedView as any)(sharedToAll || sharedIds.indexOf(member.accountId)!==-1));
    });
    return result;
  },
  sharedCartridge(onclick: string): string {
    const
      sharedProfiles = this.sharedMembers(),
      title = i18n.get('sharingtooltip',sharedProfiles.length - 1); //-1 because we do not count ourselves

    return `<span class="shared-card" data-fw-onclick="${onclick}" titlehtml="${title}">
    ${sharedProfiles.map((profile: any)=>`<span><img src="${profile.thumb()}"/></span>`).join('')}
    <span>${sharedProfiles.length}</span>
</span>`

  }
}

export default ISharableByMemberProto;
